/** Gallery product — no shop chrome. Galleries land in a later slice. */

export const disabledStorefrontPaths = ['cart', 'favorites'];

export const disabledAdminModules = [
  'orders',
  'prices',
  'promotions',
  'stock',
  'stock_alerts',
  'announcements',
  'staff',
  'products',
  'categories',
  'import',
  'import_media',
];
